import React from "react";
import { Navigate } from "react-router-dom";
import { useTenant } from "../TenantContext";
import { getLandingPathForTenant } from "../guards";
import ForbiddenPage from "./ForbiddenPage";

export default function TenantLandingRedirect() {
  const { tenant } = useTenant();
  const landing = getLandingPathForTenant(tenant);
  if (!landing) {
    return <ForbiddenPage reason="unknown-kind" />;
  }
  return <Navigate to={landing} replace />;
}
